module.exports = __webpack_public_path__ + "images/luck.jpg";